import { NavLink} from 'react-router-dom';
import './header.scss';
import logo from './Logo.svg';
import { useState } from 'react';
import { RxHamburgerMenu } from "react-icons/rx";
import { FiSearch } from "react-icons/fi";


const Header = () => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [isSearchVisible, setSearchVisible] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };
    
    const toggleSearch = () => {
        setSearchVisible(prev => !prev);
    }

    const handleLinkClick = () => {
        setMenuOpen(false); // Закрываем меню
 // Переходим по указанному пути
    }

    return (
        <header className="header">
            <div className="container">
                <div className="header__wrapper">
                    <div className="header__wrapper-top">
                        <img src={logo} alt="logo" />
                        <div className="header__wrapper-descr">
                            <h1>Финансовая помощь в любое время!</h1>
                        </div>
                        <button className="burger" onClick={toggleMenu}>
                        <RxHamburgerMenu />
                        </button>
                    </div>
                    
                    <div className="header__divider"></div>
                    <div className={`header__wrapper-bottom ${isMenuOpen ? 'open' : ''}`}>
                        <NavLink to="/" onClick={() => handleLinkClick("/")}>Займы</NavLink>
                        <NavLink to="/loans" onClick={() => handleLinkClick("/loans")}>Кредиты</NavLink>
                        <NavLink to="/credit-card" onClick={() => handleLinkClick("/credit-card")}>Кредитные карты</NavLink>
                        <NavLink to="/debit-card" onClick={() => handleLinkClick("/debit-card")}>Дебетовые карты</NavLink>
                        <NavLink to="/cookies" onClick={() => handleLinkClick("/cookies")}>Cookies</NavLink>
                        <NavLink to="/dataProtection" onClick={() => handleLinkClick("/dataProtection")}>Защита данных</NavLink>
                        <NavLink to="/usage" onClick={() => handleLinkClick("/usage")}>Использование</NavLink>
                        <NavLink to="/contacts" onClick={() => handleLinkClick("/contacts")}>Контакты</NavLink>
                        <NavLink to="/policy" onClick={() => handleLinkClick("/policy")}>Политика конфиденциальности</NavLink>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;